@theme {
  --color-nsw-grey-50: var(--nsw-grey-50);
  --color-nsw-grey-100: var(--nsw-grey-100);
  --color-nsw-grey-150: var(--nsw-grey-150);
  --color-nsw-grey-200: var(--nsw-grey-200);
  --color-nsw-grey-250: var(--nsw-grey-250);
  --color-nsw-grey-300: var(--nsw-grey-300);
  --color-nsw-grey-350: var(--nsw-grey-350);
  --color-nsw-grey-400: var(--nsw-grey-400);
  --color-nsw-grey-450: var(--nsw-grey-450);
  --color-nsw-grey-500: var(--nsw-grey-500);
  --color-nsw-grey-550: var(--nsw-grey-550);
  --color-nsw-grey-600: var(--nsw-grey-600);
  --color-nsw-grey-650: var(--nsw-grey-650);
  --color-nsw-grey-700: var(--nsw-grey-700);
  --color-nsw-grey-750: var(--nsw-grey-750);
  --color-nsw-grey-800: var(--nsw-grey-800);
  --color-nsw-grey-850: var(--nsw-grey-850);
  --color-nsw-grey-900: var(--nsw-grey-900);
  --color-nsw-grey-950: var(--nsw-grey-950);
  --color-nsw-green-50: var(--nsw-green-50);
  --color-nsw-green-100: var(--nsw-green-100);
  --color-nsw-green-150: var(--nsw-green-150);
  --color-nsw-green-200: var(--nsw-green-200);
  --color-nsw-green-250: var(--nsw-green-250);
  --color-nsw-green-300: var(--nsw-green-300);
  --color-nsw-green-350: var(--nsw-green-350);
  --color-nsw-green-400: var(--nsw-green-400);
  --color-nsw-green-450: var(--nsw-green-450);
  --color-nsw-green-500: var(--nsw-green-500);
  --color-nsw-green-550: var(--nsw-green-550);
  --color-nsw-green-600: var(--nsw-green-600);
  --color-nsw-green-650: var(--nsw-green-650);
  --color-nsw-green-700: var(--nsw-green-700);
  --color-nsw-green-750: var(--nsw-green-750);
  --color-nsw-green-800: var(--nsw-green-800);
  --color-nsw-green-850: var(--nsw-green-850);
  --color-nsw-green-900: var(--nsw-green-900);
  --color-nsw-green-950: var(--nsw-green-950);
  --color-nsw-teal-50: var(--nsw-teal-50);
  --color-nsw-teal-100: var(--nsw-teal-100);
  --color-nsw-teal-150: var(--nsw-teal-150);
  --color-nsw-teal-200: var(--nsw-teal-200);
  --color-nsw-teal-250: var(--nsw-teal-250);
  --color-nsw-teal-300: var(--nsw-teal-300);
  --color-nsw-teal-350: var(--nsw-teal-350);
  --color-nsw-teal-400: var(--nsw-teal-400);
  --color-nsw-teal-450: var(--nsw-teal-450);
  --color-nsw-teal-500: var(--nsw-teal-500);
  --color-nsw-teal-550: var(--nsw-teal-550);
  --color-nsw-teal-600: var(--nsw-teal-600);
  --color-nsw-teal-650: var(--nsw-teal-650);
  --color-nsw-teal-700: var(--nsw-teal-700);
  --color-nsw-teal-750: var(--nsw-teal-750);
  --color-nsw-teal-800: var(--nsw-teal-800);
  --color-nsw-teal-850: var(--nsw-teal-850);
  --color-nsw-teal-900: var(--nsw-teal-900);
  --color-nsw-teal-950: var(--nsw-teal-950);
  --color-nsw-blue-50: var(--nsw-blue-50);
  --color-nsw-blue-100: var(--nsw-blue-100);
  --color-nsw-blue-150: var(--nsw-blue-150);
  --color-nsw-blue-200: var(--nsw-blue-200);
  --color-nsw-blue-250: var(--nsw-blue-250);
  --color-nsw-blue-300: var(--nsw-blue-300);
  --color-nsw-blue-350: var(--nsw-blue-350);
  --color-nsw-blue-400: var(--nsw-blue-400);
  --color-nsw-blue-450: var(--nsw-blue-450);
  --color-nsw-blue-500: var(--nsw-blue-500);
  --color-nsw-blue-550: var(--nsw-blue-550);
  --color-nsw-blue-600: var(--nsw-blue-600);
  --color-nsw-blue-650: var(--nsw-blue-650);
  --color-nsw-blue-700: var(--nsw-blue-700);
  --color-nsw-blue-750: var(--nsw-blue-750);
  --color-nsw-blue-800: var(--nsw-blue-800);
  --color-nsw-blue-850: var(--nsw-blue-850);
  --color-nsw-blue-900: var(--nsw-blue-900);
  --color-nsw-blue-950: var(--nsw-blue-950);
  --color-nsw-purple-50: var(--nsw-purple-50);
  --color-nsw-purple-100: var(--nsw-purple-100);
  --color-nsw-purple-150: var(--nsw-purple-150);
  --color-nsw-purple-200: var(--nsw-purple-200);
  --color-nsw-purple-250: var(--nsw-purple-250);
  --color-nsw-purple-300: var(--nsw-purple-300);
  --color-nsw-purple-350: var(--nsw-purple-350);
  --color-nsw-purple-400: var(--nsw-purple-400);
  --color-nsw-purple-450: var(--nsw-purple-450);
  --color-nsw-purple-500: var(--nsw-purple-500);
  --color-nsw-purple-550: var(--nsw-purple-550);
  --color-nsw-purple-600: var(--nsw-purple-600);
  --color-nsw-purple-650: var(--nsw-purple-650);
  --color-nsw-purple-700: var(--nsw-purple-700);
  --color-nsw-purple-750: var(--nsw-purple-750);
  --color-nsw-purple-800: var(--nsw-purple-800);
  --color-nsw-purple-850: var(--nsw-purple-850);
  --color-nsw-purple-900: var(--nsw-purple-900);
  --color-nsw-purple-950: var(--nsw-purple-950);
  --color-nsw-fuchsia-50: var(--nsw-fuchsia-50);
  --color-nsw-fuchsia-100: var(--nsw-fuchsia-100);
  --color-nsw-fuchsia-150: var(--nsw-fuchsia-150);
  --color-nsw-fuchsia-200: var(--nsw-fuchsia-200);
  --color-nsw-fuchsia-250: var(--nsw-fuchsia-250);
  --color-nsw-fuchsia-300: var(--nsw-fuchsia-300);
  --color-nsw-fuchsia-350: var(--nsw-fuchsia-350);
  --color-nsw-fuchsia-400: var(--nsw-fuchsia-400);
  --color-nsw-fuchsia-450: var(--nsw-fuchsia-450);
  --color-nsw-fuchsia-500: var(--nsw-fuchsia-500);
  --color-nsw-fuchsia-550: var(--nsw-fuchsia-550);
  --color-nsw-fuchsia-600: var(--nsw-fuchsia-600);
  --color-nsw-fuchsia-650: var(--nsw-fuchsia-650);
  --color-nsw-fuchsia-700: var(--nsw-fuchsia-700);
  --color-nsw-fuchsia-750: var(--nsw-fuchsia-750);
  --color-nsw-fuchsia-800: var(--nsw-fuchsia-800);
  --color-nsw-fuchsia-850: var(--nsw-fuchsia-850);
  --color-nsw-fuchsia-900: var(--nsw-fuchsia-900);
  --color-nsw-fuchsia-950: var(--nsw-fuchsia-950);
  --color-nsw-red-50: var(--nsw-red-50);
  --color-nsw-red-100: var(--nsw-red-100);
  --color-nsw-red-150: var(--nsw-red-150);
  --color-nsw-red-200: var(--nsw-red-200);
  --color-nsw-red-250: var(--nsw-red-250);
  --color-nsw-red-300: var(--nsw-red-300);
  --color-nsw-red-350: var(--nsw-red-350);
  --color-nsw-red-400: var(--nsw-red-400);
  --color-nsw-red-450: var(--nsw-red-450);
  --color-nsw-red-500: var(--nsw-red-500);
  --color-nsw-red-550: var(--nsw-red-550);
  --color-nsw-red-600: var(--nsw-red-600);
  --color-nsw-red-650: var(--nsw-red-650);
  --color-nsw-red-700: var(--nsw-red-700);
  --color-nsw-red-750: var(--nsw-red-750);
  --color-nsw-red-800: var(--nsw-red-800);
  --color-nsw-red-850: var(--nsw-red-850);
  --color-nsw-red-900: var(--nsw-red-900);
  --color-nsw-red-950: var(--nsw-red-950);
  --color-nsw-orange-50: var(--nsw-orange-50);
  --color-nsw-orange-100: var(--nsw-orange-100);
  --color-nsw-orange-150: var(--nsw-orange-150);
  --color-nsw-orange-200: var(--nsw-orange-200);
  --color-nsw-orange-250: var(--nsw-orange-250);
  --color-nsw-orange-300: var(--nsw-orange-300);
  --color-nsw-orange-350: var(--nsw-orange-350);
  --color-nsw-orange-400: var(--nsw-orange-400);
  --color-nsw-orange-450: var(--nsw-orange-450);
  --color-nsw-orange-500: var(--nsw-orange-500);
  --color-nsw-orange-550: var(--nsw-orange-550);
  --color-nsw-orange-600: var(--nsw-orange-600);
  --color-nsw-orange-650: var(--nsw-orange-650);
  --color-nsw-orange-700: var(--nsw-orange-700);
  --color-nsw-orange-750: var(--nsw-orange-750);
  --color-nsw-orange-800: var(--nsw-orange-800);
  --color-nsw-orange-850: var(--nsw-orange-850);
  --color-nsw-orange-900: var(--nsw-orange-900);
  --color-nsw-orange-950: var(--nsw-orange-950);
  --color-nsw-yellow-50: var(--nsw-yellow-50);
  --color-nsw-yellow-100: var(--nsw-yellow-100);
  --color-nsw-yellow-150: var(--nsw-yellow-150);
  --color-nsw-yellow-200: var(--nsw-yellow-200);
  --color-nsw-yellow-250: var(--nsw-yellow-250);
  --color-nsw-yellow-300: var(--nsw-yellow-300);
  --color-nsw-yellow-350: var(--nsw-yellow-350);
  --color-nsw-yellow-400: var(--nsw-yellow-400);
  --color-nsw-yellow-450: var(--nsw-yellow-450);
  --color-nsw-yellow-500: var(--nsw-yellow-500);
  --color-nsw-yellow-550: var(--nsw-yellow-550);
  --color-nsw-yellow-600: var(--nsw-yellow-600);
  --color-nsw-yellow-650: var(--nsw-yellow-650);
  --color-nsw-yellow-700: var(--nsw-yellow-700);
  --color-nsw-yellow-750: var(--nsw-yellow-750);
  --color-nsw-yellow-800: var(--nsw-yellow-800);
  --color-nsw-yellow-850: var(--nsw-yellow-850);
  --color-nsw-yellow-900: var(--nsw-yellow-900);
  --color-nsw-yellow-950: var(--nsw-yellow-950);
  --color-nsw-brown-50: var(--nsw-brown-50);
  --color-nsw-brown-100: var(--nsw-brown-100);
  --color-nsw-brown-150: var(--nsw-brown-150);
  --color-nsw-brown-200: var(--nsw-brown-200);
  --color-nsw-brown-250: var(--nsw-brown-250);
  --color-nsw-brown-300: var(--nsw-brown-300);
  --color-nsw-brown-350: var(--nsw-brown-350);
  --color-nsw-brown-400: var(--nsw-brown-400);
  --color-nsw-brown-450: var(--nsw-brown-450);
  --color-nsw-brown-500: var(--nsw-brown-500);
  --color-nsw-brown-550: var(--nsw-brown-550);
  --color-nsw-brown-600: var(--nsw-brown-600);
  --color-nsw-brown-650: var(--nsw-brown-650);
  --color-nsw-brown-700: var(--nsw-brown-700);
  --color-nsw-brown-750: var(--nsw-brown-750);
  --color-nsw-brown-800: var(--nsw-brown-800);
  --color-nsw-brown-850: var(--nsw-brown-850);
  --color-nsw-brown-900: var(--nsw-brown-900);
  --color-nsw-brown-950: var(--nsw-brown-950);
  --color-nsw-aboriginal-grey-50: var(--nsw-aboriginal-grey-50);
  --color-nsw-aboriginal-grey-100: var(--nsw-aboriginal-grey-100);
  --color-nsw-aboriginal-grey-150: var(--nsw-aboriginal-grey-150);
  --color-nsw-aboriginal-grey-200: var(--nsw-aboriginal-grey-200);
  --color-nsw-aboriginal-grey-250: var(--nsw-aboriginal-grey-250);
  --color-nsw-aboriginal-grey-300: var(--nsw-aboriginal-grey-300);
  --color-nsw-aboriginal-grey-350: var(--nsw-aboriginal-grey-350);
  --color-nsw-aboriginal-grey-400: var(--nsw-aboriginal-grey-400);
  --color-nsw-aboriginal-grey-450: var(--nsw-aboriginal-grey-450);
  --color-nsw-aboriginal-grey-500: var(--nsw-aboriginal-grey-500);
  --color-nsw-aboriginal-grey-550: var(--nsw-aboriginal-grey-550);
  --color-nsw-aboriginal-grey-600: var(--nsw-aboriginal-grey-600);
  --color-nsw-aboriginal-grey-650: var(--nsw-aboriginal-grey-650);
  --color-nsw-aboriginal-grey-700: var(--nsw-aboriginal-grey-700);
  --color-nsw-aboriginal-grey-750: var(--nsw-aboriginal-grey-750);
  --color-nsw-aboriginal-grey-800: var(--nsw-aboriginal-grey-800);
  --color-nsw-aboriginal-grey-850: var(--nsw-aboriginal-grey-850);
  --color-nsw-aboriginal-grey-900: var(--nsw-aboriginal-grey-900);
  --color-nsw-aboriginal-grey-950: var(--nsw-aboriginal-grey-950);
  --color-nsw-aboriginal-red-50: var(--nsw-aboriginal-red-50);
  --color-nsw-aboriginal-red-100: var(--nsw-aboriginal-red-100);
  --color-nsw-aboriginal-red-150: var(--nsw-aboriginal-red-150);
  --color-nsw-aboriginal-red-200: var(--nsw-aboriginal-red-200);
  --color-nsw-aboriginal-red-250: var(--nsw-aboriginal-red-250);
  --color-nsw-aboriginal-red-300: var(--nsw-aboriginal-red-300);
  --color-nsw-aboriginal-red-350: var(--nsw-aboriginal-red-350);
  --color-nsw-aboriginal-red-400: var(--nsw-aboriginal-red-400);
  --color-nsw-aboriginal-red-450: var(--nsw-aboriginal-red-450);
  --color-nsw-aboriginal-red-500: var(--nsw-aboriginal-red-500);
  --color-nsw-aboriginal-red-550: var(--nsw-aboriginal-red-550);
  --color-nsw-aboriginal-red-600: var(--nsw-aboriginal-red-600);
  --color-nsw-aboriginal-red-650: var(--nsw-aboriginal-red-650);
  --color-nsw-aboriginal-red-700: var(--nsw-aboriginal-red-700);
  --color-nsw-aboriginal-red-750: var(--nsw-aboriginal-red-750);
  --color-nsw-aboriginal-red-800: var(--nsw-aboriginal-red-800);
  --color-nsw-aboriginal-red-850: var(--nsw-aboriginal-red-850);
  --color-nsw-aboriginal-red-900: var(--nsw-aboriginal-red-900);
  --color-nsw-aboriginal-red-950: var(--nsw-aboriginal-red-950);
  --color-nsw-aboriginal-orange-50: var(--nsw-aboriginal-orange-50);
  --color-nsw-aboriginal-orange-100: var(--nsw-aboriginal-orange-100);
  --color-nsw-aboriginal-orange-150: var(--nsw-aboriginal-orange-150);
  --color-nsw-aboriginal-orange-200: var(--nsw-aboriginal-orange-200);
  --color-nsw-aboriginal-orange-250: var(--nsw-aboriginal-orange-250);
  --color-nsw-aboriginal-orange-300: var(--nsw-aboriginal-orange-300);
  --color-nsw-aboriginal-orange-350: var(--nsw-aboriginal-orange-350);
  --color-nsw-aboriginal-orange-400: var(--nsw-aboriginal-orange-400);
  --color-nsw-aboriginal-orange-450: var(--nsw-aboriginal-orange-450);
  --color-nsw-aboriginal-orange-500: var(--nsw-aboriginal-orange-500);
  --color-nsw-aboriginal-orange-550: var(--nsw-aboriginal-orange-550);
  --color-nsw-aboriginal-orange-600: var(--nsw-aboriginal-orange-600);
  --color-nsw-aboriginal-orange-650: var(--nsw-aboriginal-orange-650);
  --color-nsw-aboriginal-orange-700: var(--nsw-aboriginal-orange-700);
  --color-nsw-aboriginal-orange-750: var(--nsw-aboriginal-orange-750);
  --color-nsw-aboriginal-orange-800: var(--nsw-aboriginal-orange-800);
  --color-nsw-aboriginal-orange-850: var(--nsw-aboriginal-orange-850);
  --color-nsw-aboriginal-orange-900: var(--nsw-aboriginal-orange-900);
  --color-nsw-aboriginal-orange-950: var(--nsw-aboriginal-orange-950);
  --color-nsw-aboriginal-brown-50: var(--nsw-aboriginal-brown-50);
  --color-nsw-aboriginal-brown-100: var(--nsw-aboriginal-brown-100);
  --color-nsw-aboriginal-brown-150: var(--nsw-aboriginal-brown-150);
  --color-nsw-aboriginal-brown-200: var(--nsw-aboriginal-brown-200);
  --color-nsw-aboriginal-brown-250: var(--nsw-aboriginal-brown-250);
  --color-nsw-aboriginal-brown-300: var(--nsw-aboriginal-brown-300);
  --color-nsw-aboriginal-brown-350: var(--nsw-aboriginal-brown-350);
  --color-nsw-aboriginal-brown-400: var(--nsw-aboriginal-brown-400);
  --color-nsw-aboriginal-brown-450: var(--nsw-aboriginal-brown-450);
  --color-nsw-aboriginal-brown-500: var(--nsw-aboriginal-brown-500);
  --color-nsw-aboriginal-brown-550: var(--nsw-aboriginal-brown-550);
  --color-nsw-aboriginal-brown-600: var(--nsw-aboriginal-brown-600);
  --color-nsw-aboriginal-brown-650: var(--nsw-aboriginal-brown-650);
  --color-nsw-aboriginal-brown-700: var(--nsw-aboriginal-brown-700);
  --color-nsw-aboriginal-brown-750: var(--nsw-aboriginal-brown-750);
  --color-nsw-aboriginal-brown-800: var(--nsw-aboriginal-brown-800);
  --color-nsw-aboriginal-brown-850: var(--nsw-aboriginal-brown-850);
  --color-nsw-aboriginal-brown-900: var(--nsw-aboriginal-brown-900);
  --color-nsw-aboriginal-brown-950: var(--nsw-aboriginal-brown-950);
  --color-nsw-aboriginal-yellow-50: var(--nsw-aboriginal-yellow-50);
  --color-nsw-aboriginal-yellow-100: var(--nsw-aboriginal-yellow-100);
  --color-nsw-aboriginal-yellow-150: var(--nsw-aboriginal-yellow-150);
  --color-nsw-aboriginal-yellow-200: var(--nsw-aboriginal-yellow-200);
  --color-nsw-aboriginal-yellow-250: var(--nsw-aboriginal-yellow-250);
  --color-nsw-aboriginal-yellow-300: var(--nsw-aboriginal-yellow-300);
  --color-nsw-aboriginal-yellow-350: var(--nsw-aboriginal-yellow-350);
  --color-nsw-aboriginal-yellow-400: var(--nsw-aboriginal-yellow-400);
  --color-nsw-aboriginal-yellow-450: var(--nsw-aboriginal-yellow-450);
  --color-nsw-aboriginal-yellow-500: var(--nsw-aboriginal-yellow-500);
  --color-nsw-aboriginal-yellow-550: var(--nsw-aboriginal-yellow-550);
  --color-nsw-aboriginal-yellow-600: var(--nsw-aboriginal-yellow-600);
  --color-nsw-aboriginal-yellow-650: var(--nsw-aboriginal-yellow-650);
  --color-nsw-aboriginal-yellow-700: var(--nsw-aboriginal-yellow-700);
  --color-nsw-aboriginal-yellow-750: var(--nsw-aboriginal-yellow-750);
  --color-nsw-aboriginal-yellow-800: var(--nsw-aboriginal-yellow-800);
  --color-nsw-aboriginal-yellow-850: var(--nsw-aboriginal-yellow-850);
  --color-nsw-aboriginal-yellow-900: var(--nsw-aboriginal-yellow-900);
  --color-nsw-aboriginal-yellow-950: var(--nsw-aboriginal-yellow-950);
  --color-nsw-aboriginal-green-50: var(--nsw-aboriginal-green-50);
  --color-nsw-aboriginal-green-100: var(--nsw-aboriginal-green-100);
  --color-nsw-aboriginal-green-150: var(--nsw-aboriginal-green-150);
  --color-nsw-aboriginal-green-200: var(--nsw-aboriginal-green-200);
  --color-nsw-aboriginal-green-250: var(--nsw-aboriginal-green-250);
  --color-nsw-aboriginal-green-300: var(--nsw-aboriginal-green-300);
  --color-nsw-aboriginal-green-350: var(--nsw-aboriginal-green-350);
  --color-nsw-aboriginal-green-400: var(--nsw-aboriginal-green-400);
  --color-nsw-aboriginal-green-450: var(--nsw-aboriginal-green-450);
  --color-nsw-aboriginal-green-500: var(--nsw-aboriginal-green-500);
  --color-nsw-aboriginal-green-550: var(--nsw-aboriginal-green-550);
  --color-nsw-aboriginal-green-600: var(--nsw-aboriginal-green-600);
  --color-nsw-aboriginal-green-650: var(--nsw-aboriginal-green-650);
  --color-nsw-aboriginal-green-700: var(--nsw-aboriginal-green-700);
  --color-nsw-aboriginal-green-750: var(--nsw-aboriginal-green-750);
  --color-nsw-aboriginal-green-800: var(--nsw-aboriginal-green-800);
  --color-nsw-aboriginal-green-850: var(--nsw-aboriginal-green-850);
  --color-nsw-aboriginal-green-900: var(--nsw-aboriginal-green-900);
  --color-nsw-aboriginal-green-950: var(--nsw-aboriginal-green-950);
  --color-nsw-aboriginal-blue-50: var(--nsw-aboriginal-blue-50);
  --color-nsw-aboriginal-blue-100: var(--nsw-aboriginal-blue-100);
  --color-nsw-aboriginal-blue-150: var(--nsw-aboriginal-blue-150);
  --color-nsw-aboriginal-blue-200: var(--nsw-aboriginal-blue-200);
  --color-nsw-aboriginal-blue-250: var(--nsw-aboriginal-blue-250);
  --color-nsw-aboriginal-blue-300: var(--nsw-aboriginal-blue-300);
  --color-nsw-aboriginal-blue-350: var(--nsw-aboriginal-blue-350);
  --color-nsw-aboriginal-blue-400: var(--nsw-aboriginal-blue-400);
  --color-nsw-aboriginal-blue-450: var(--nsw-aboriginal-blue-450);
  --color-nsw-aboriginal-blue-500: var(--nsw-aboriginal-blue-500);
  --color-nsw-aboriginal-blue-550: var(--nsw-aboriginal-blue-550);
  --color-nsw-aboriginal-blue-600: var(--nsw-aboriginal-blue-600);
  --color-nsw-aboriginal-blue-650: var(--nsw-aboriginal-blue-650);
  --color-nsw-aboriginal-blue-700: var(--nsw-aboriginal-blue-700);
  --color-nsw-aboriginal-blue-750: var(--nsw-aboriginal-blue-750);
  --color-nsw-aboriginal-blue-800: var(--nsw-aboriginal-blue-800);
  --color-nsw-aboriginal-blue-850: var(--nsw-aboriginal-blue-850);
  --color-nsw-aboriginal-blue-900: var(--nsw-aboriginal-blue-900);
  --color-nsw-aboriginal-blue-950: var(--nsw-aboriginal-blue-950);
  --color-nsw-aboriginal-purple-50: var(--nsw-aboriginal-purple-50);
  --color-nsw-aboriginal-purple-100: var(--nsw-aboriginal-purple-100);
  --color-nsw-aboriginal-purple-150: var(--nsw-aboriginal-purple-150);
  --color-nsw-aboriginal-purple-200: var(--nsw-aboriginal-purple-200);
  --color-nsw-aboriginal-purple-250: var(--nsw-aboriginal-purple-250);
  --color-nsw-aboriginal-purple-300: var(--nsw-aboriginal-purple-300);
  --color-nsw-aboriginal-purple-350: var(--nsw-aboriginal-purple-350);
  --color-nsw-aboriginal-purple-400: var(--nsw-aboriginal-purple-400);
  --color-nsw-aboriginal-purple-450: var(--nsw-aboriginal-purple-450);
  --color-nsw-aboriginal-purple-500: var(--nsw-aboriginal-purple-500);
  --color-nsw-aboriginal-purple-550: var(--nsw-aboriginal-purple-550);
  --color-nsw-aboriginal-purple-600: var(--nsw-aboriginal-purple-600);
  --color-nsw-aboriginal-purple-650: var(--nsw-aboriginal-purple-650);
  --color-nsw-aboriginal-purple-700: var(--nsw-aboriginal-purple-700);
  --color-nsw-aboriginal-purple-750: var(--nsw-aboriginal-purple-750);
  --color-nsw-aboriginal-purple-800: var(--nsw-aboriginal-purple-800);
  --color-nsw-aboriginal-purple-850: var(--nsw-aboriginal-purple-850);
  --color-nsw-aboriginal-purple-900: var(--nsw-aboriginal-purple-900);
  --color-nsw-aboriginal-purple-950: var(--nsw-aboriginal-purple-950);
  --color-success-50: var(--success-50);
  --color-success-100: var(--success-100);
  --color-success-150: var(--success-150);
  --color-success-200: var(--success-200);
  --color-success-250: var(--success-250);
  --color-success-300: var(--success-300);
  --color-success-350: var(--success-350);
  --color-success-400: var(--success-400);
  --color-success-450: var(--success-450);
  --color-success-500: var(--success-500);
  --color-success-550: var(--success-550);
  --color-success-600: var(--success-600);
  --color-success-650: var(--success-650);
  --color-success-700: var(--success-700);
  --color-success-750: var(--success-750);
  --color-success-800: var(--success-800);
  --color-success-850: var(--success-850);
  --color-success-900: var(--success-900);
  --color-success-950: var(--success-950);
  --color-warning-50: var(--warning-50);
  --color-warning-100: var(--warning-100);
  --color-warning-150: var(--warning-150);
  --color-warning-200: var(--warning-200);
  --color-warning-250: var(--warning-250);
  --color-warning-300: var(--warning-300);
  --color-warning-350: var(--warning-350);
  --color-warning-400: var(--warning-400);
  --color-warning-450: var(--warning-450);
  --color-warning-500: var(--warning-500);
  --color-warning-550: var(--warning-550);
  --color-warning-600: var(--warning-600);
  --color-warning-650: var(--warning-650);
  --color-warning-700: var(--warning-700);
  --color-warning-750: var(--warning-750);
  --color-warning-800: var(--warning-800);
  --color-warning-850: var(--warning-850);
  --color-warning-900: var(--warning-900);
  --color-warning-950: var(--warning-950);
  --color-danger-50: var(--danger-50);
  --color-danger-100: var(--danger-100);
  --color-danger-150: var(--danger-150);
  --color-danger-200: var(--danger-200);
  --color-danger-250: var(--danger-250);
  --color-danger-300: var(--danger-300);
  --color-danger-350: var(--danger-350);
  --color-danger-400: var(--danger-400);
  --color-danger-450: var(--danger-450);
  --color-danger-500: var(--danger-500);
  --color-danger-550: var(--danger-550);
  --color-danger-600: var(--danger-600);
  --color-danger-650: var(--danger-650);
  --color-danger-700: var(--danger-700);
  --color-danger-750: var(--danger-750);
  --color-danger-800: var(--danger-800);
  --color-danger-850: var(--danger-850);
  --color-danger-900: var(--danger-900);
  --color-danger-950: var(--danger-950);
  --color-info-50: var(--info-50);
  --color-info-100: var(--info-100);
  --color-info-150: var(--info-150);
  --color-info-200: var(--info-200);
  --color-info-250: var(--info-250);
  --color-info-300: var(--info-300);
  --color-info-350: var(--info-350);
  --color-info-400: var(--info-400);
  --color-info-450: var(--info-450);
  --color-info-500: var(--info-500);
  --color-info-550: var(--info-550);
  --color-info-600: var(--info-600);
  --color-info-650: var(--info-650);
  --color-info-700: var(--info-700);
  --color-info-750: var(--info-750);
  --color-info-800: var(--info-800);
  --color-info-850: var(--info-850);
  --color-info-900: var(--info-900);
  --color-info-950: var(--info-950);
  --color-white: var(--white);
  --color-black: var(--black);
}

:root {
  --nsw-grey-50: hsl(0, 0%, 98.039216%);
  --nsw-grey-100: hsl(0, 0%, 96.078431%);
  --nsw-grey-150: hsl(0, 0%, 94.117647%);
  --nsw-grey-200: hsl(0, 0%, 92.156863%);
  --nsw-grey-250: hsl(200, 5.660377%, 89.607843%);
  --nsw-grey-300: hsl(195, 6.060606%, 87.058824%);
  --nsw-grey-350: hsl(197.142857, 8.860759%, 84.509804%);
  --nsw-grey-400: hsl(200, 9.89011%, 82.156863%);
  --nsw-grey-450: hsl(204, 6.25%, 68.627451%);
  --nsw-grey-500: hsl(198, 4.385965%, 55.294118%);
  --nsw-grey-550: hsl(198, 4.587156%, 42.745098%);
  --nsw-grey-600: hsl(201.818182, 7.006369%, 30.784314%);
  --nsw-grey-650: hsl(204, 7.352941%, 26.666667%);
  --nsw-grey-700: hsl(204, 8.62069%, 22.745098%);
  --nsw-grey-750: hsl(204, 10.416667%, 18.823529%);
  --nsw-grey-800: hsl(206.666667, 11.688312%, 15.098039%);
  --nsw-grey-850: hsl(205.714286, 12.727273%, 10.784314%);
  --nsw-grey-900: hsl(204, 15.151515%, 6.470588%);
  --nsw-grey-950: hsl(210, 28.571429%, 2.745098%);
  --nsw-green-50: hsl(126, 100%, 98.039216%);
  --nsw-green-100: hsl(127.058824, 80.952381%, 95.882353%);
  --nsw-green-150: hsl(127.5, 80%, 94.117647%);
  --nsw-green-200: hsl(127.741935, 75.609756%, 91.960784%);
  --nsw-green-250: hsl(127.5, 71.428571%, 89.019608%);
  --nsw-green-300: hsl(128.4, 69.444444%, 85.882353%);
  --nsw-green-350: hsl(129.152542, 66.292135%, 82.54902%);
  --nsw-green-400: hsl(129.565217, 65.714286%, 79.411765%);
  --nsw-green-450: hsl(130.243902, 53.947368%, 70.196078%);
  --nsw-green-500: hsl(131.632653, 49%, 60.784314%);
  --nsw-green-550: hsl(134.745763, 46.456693%, 50.196078%);
  --nsw-green-600: hsl(144.352941, 100%, 33.333333%);
  --nsw-green-650: hsl(139.111111, 90.604027%, 29.215686%);
  --nsw-green-700: hsl(133.888889, 88.52459%, 23.921569%);
  --nsw-green-750: hsl(128.372093, 93.478261%, 18.039216%);
  --nsw-green-800: hsl(120, 100%, 12.54902%);
  --nsw-green-850: hsl(120, 100%, 9.411765%);
  --nsw-green-900: hsl(120, 100%, 6.27451%);
  --nsw-green-950: hsl(120, 100%, 3.333333%);
  --nsw-teal-50: hsl(173.333333, 52.941176%, 96.666667%);
  --nsw-teal-100: hsl(172.5, 50%, 93.72549%);
  --nsw-teal-150: hsl(171.818182, 45.833333%, 90.588235%);
  --nsw-teal-200: hsl(171.724138, 46.031746%, 87.647059%);
  --nsw-teal-250: hsl(175.609756, 49.39759%, 83.72549%);
  --nsw-teal-300: hsl(180, 50.943396%, 79.215686%);
  --nsw-teal-350: hsl(184.225352, 57.723577%, 75.882353%);
  --nsw-teal-400: hsl(186.741573, 63.120567%, 72.352941%);
  --nsw-teal-450: hsl(187.333333, 48.387097%, 63.529412%);
  --nsw-teal-500: hsl(188.571429, 39.393939%, 54.705882%);
  --nsw-teal-550: hsl(188.387097, 39.914163%, 45.686275%);
  --nsw-teal-600: hsl(188.75, 51.06383%, 36.862745%);
  --nsw-teal-650: hsl(188.372093, 53.75%, 31.372549%);
  --nsw-teal-700: hsl(187.792208, 57.894737%, 26.078431%);
  --nsw-teal-750: hsl(188.823529, 62.962963%, 21.176471%);
  --nsw-teal-800: hsl(188, 73.170732%, 16.078431%);
  --nsw-teal-850: hsl(187.346939, 85.964912%, 11.176471%);
  --nsw-teal-900: hsl(188.571429, 94.594595%, 7.254902%);
  --nsw-teal-950: hsl(189, 100%, 3.921569%);
  --nsw-blue-50: hsl(196, 100%, 97.058824%);
  --nsw-blue-100: hsl(200, 100%, 94.705882%);
  --nsw-blue-150: hsl(198.461538, 95.121951%, 91.960784%);
  --nsw-blue-200: hsl(199.2, 92.592593%, 89.411765%);
  --nsw-blue-250: hsl(198.181818, 97.058824%, 86.666667%);
  --nsw-blue-300: hsl(197.560976, 100%, 83.921569%);
  --nsw-blue-350: hsl(197.142857, 100%, 80.784314%);
  --nsw-blue-400: hsl(196.173913, 100%, 77.45098%);
  --nsw-blue-450: hsl(199.636364, 100%, 67.647059%);
  --nsw-blue-500: hsl(202.396313, 100%, 57.45098%);
  --nsw-blue-550: hsl(206.352941, 100%, 50%);
  --nsw-blue-600: hsl(217.339056, 98.312236%, 53.529412%);
  --nsw-blue-650: hsl(216.6, 89.285714%, 43.921569%);
  --nsw-blue-700: hsl(216.071429, 94.382022%, 34.901961%);
  --nsw-blue-750: hsl(216.716418, 97.101449%, 27.058824%);
  --nsw-blue-800: hsl(217.2, 100%, 19.607843%);
  --nsw-blue-850: hsl(219.74026, 100%, 15.098039%);
  --nsw-blue-900: hsl(222.545455, 100%, 10.784314%);
  --nsw-blue-950: hsl(229.411765, 100%, 6.666667%);
  --nsw-purple-50: hsl(255, 100%, 98.431373%);
  --nsw-purple-100: hsl(248, 100%, 97.058824%);
  --nsw-purple-150: hsl(250.909091, 91.666667%, 95.294118%);
  --nsw-purple-200: hsl(250.714286, 87.5%, 93.72549%);
  --nsw-purple-250: hsl(251.351351, 94.871795%, 92.352941%);
  --nsw-purple-300: hsl(253.043478, 95.833333%, 90.588235%);
  --nsw-purple-350: hsl(253.090909, 100%, 89.215686%);
  --nsw-purple-400: hsl(254.0625, 100%, 87.45098%);
  --nsw-purple-450: hsl(253.953488, 93.478261%, 81.960784%);
  --nsw-purple-500: hsl(253.888889, 90%, 76.470588%);
  --nsw-purple-550: hsl(255.114504, 86.754967%, 70.392157%);
  --nsw-purple-600: hsl(256.538462, 84.782609%, 63.921569%);
  --nsw-purple-650: hsl(260.142857, 59.322034%, 53.72549%);
  --nsw-purple-700: hsl(264.193548, 55.357143%, 43.921569%);
  --nsw-purple-750: hsl(268.073394, 62.285714%, 34.313725%);
  --nsw-purple-800: hsl(272.210526, 73.643411%, 25.294118%);
  --nsw-purple-850: hsl(273.076923, 82.978723%, 18.431373%);
  --nsw-purple-900: hsl(273, 93.75%, 12.54902%);
  --nsw-purple-950: hsl(269.230769, 100%, 7.647059%);
  --nsw-fuchsia-50: hsl(313.333333, 100%, 98.235294%);
  --nsw-fuchsia-100: hsl(321.176471, 100%, 96.666667%);
  --nsw-fuchsia-150: hsl(320, 92.307692%, 94.901961%);
  --nsw-fuchsia-200: hsl(321.290323, 88.571429%, 93.137255%);
  --nsw-fuchsia-250: hsl(318.461538, 82.978723%, 90.784314%);
  --nsw-fuchsia-300: hsl(317.5, 80%, 88.235294%);
  --nsw-fuchsia-350: hsl(315, 77.777778%, 85.882353%);
  --nsw-fuchsia-400: hsl(313.333333, 74.117647%, 83.333333%);
  --nsw-fuchsia-450: hsl(314.157303, 73.553719%, 76.27451%);
  --nsw-fuchsia-500: hsl(315, 72.5%, 68.627451%);
  --nsw-fuchsia-550: hsl(314.482759, 70.731707%, 59.803922%);
  --nsw-fuchsia-600: hsl(312.964824, 84.680851%, 46.078431%);
  --nsw-fuchsia-650: hsl(313.371429, 87.939698%, 39.019608%);
  --nsw-fuchsia-700: hsl(313.509934, 92.638037%, 31.960784%);
  --nsw-fuchsia-750: hsl(313.700787, 96.946565%, 25.686275%);
  --nsw-fuchsia-800: hsl(314.257426, 100%, 19.803922%);
  --nsw-fuchsia-850: hsl(314.805195, 100%, 15.098039%);
  --nsw-fuchsia-900: hsl(316.363636, 100%, 10.784314%);
  --nsw-fuchsia-950: hsl(319.411765, 100%, 6.666667%);
  --nsw-red-50: hsl(351.428571, 100%, 98.627451%);
  --nsw-red-100: hsl(350.769231, 100%, 97.45098%);
  --nsw-red-150: hsl(350.526316, 100%, 96.27451%);
  --nsw-red-200: hsl(350.4, 100%, 95.098039%);
  --nsw-red-250: hsl(351.666667, 100%, 92.941176%);
  --nsw-red-300: hsl(351.25, 100%, 90.588235%);
  --nsw-red-350: hsl(351.864407, 100%, 88.431373%);
  --nsw-red-400: hsl(352.394366, 100%, 86.078431%);
  --nsw-red-450: hsl(353.195876, 87.387387%, 78.235294%);
  --nsw-red-500: hsl(354.098361, 79.220779%, 69.803922%);
  --nsw-red-550: hsl(353.557047, 73.399015%, 60.196078%);
  --nsw-red-600: hsl(348.556701, 82.20339%, 46.27451%);
  --nsw-red-650: hsl(347.368421, 85.929648%, 39.019608%);
  --nsw-red-700: hsl(345.810811, 91.358025%, 31.764706%);
  --nsw-red-750: hsl(344.878049, 95.348837%, 25.294118%);
  --nsw-red-800: hsl(344.848485, 100%, 19.411765%);
  --nsw-red-850: hsl(347.368421, 100%, 14.901961%);
  --nsw-red-900: hsl(351.111111, 100%, 10.588235%);
  --nsw-red-950: hsl(354.545455, 100%, 6.470588%);
  --nsw-orange-50: hsl(26.666667, 100%, 98.235294%);
  --nsw-orange-100: hsl(28.235294, 100%, 96.666667%);
  --nsw-orange-150: hsl(26.086957, 92%, 95.098039%);
  --nsw-orange-200: hsl(28, 88.235294%, 93.333333%);
  --nsw-orange-250: hsl(28.75, 96%, 90.196078%);
  --nsw-orange-300: hsl(29.090909, 100%, 87.058824%);
  --nsw-orange-350: hsl(30.714286, 100%, 83.529412%);
  --nsw-orange-400: hsl(31.176471, 100%, 80%);
  --nsw-orange-450: hsl(27.969925, 97.080292%, 73.137255%);
  --nsw-orange-500: hsl(25.398773, 95.321637%, 66.470588%);
  --nsw-orange-550: hsl(22.736842, 92.23301%, 59.607843%);
  --nsw-orange-600: hsl(20, 90%, 52.941176%);
  --nsw-orange-650: hsl(18.181818, 82.5%, 47.058824%);
  --nsw-orange-700: hsl(16.243094, 86.602871%, 40.980392%);
  --nsw-orange-750: hsl(14.545455, 93.220339%, 34.705882%);
  --nsw-orange-800: hsl(10.945946, 100%, 29.019608%);
  --nsw-orange-850: hsl(7.826087, 100%, 22.54902%);
  --nsw-orange-900: hsl(2.891566, 100%, 16.27451%);
  --nsw-orange-950: hsl(0, 100%, 10.392157%);
  --nsw-yellow-50: hsl(48, 100%, 97.058824%);
  --nsw-yellow-100: hsl(48.461538, 100%, 94.901961%);
  --nsw-yellow-150: hsl(47.027027, 100%, 92.745098%);
  --nsw-yellow-200: hsl(46.25, 100%, 90.588235%);
  --nsw-yellow-250: hsl(46.229508, 100%, 88.039216%);
  --nsw-yellow-300: hsl(46.849315, 97.333333%, 85.294118%);
  --nsw-yellow-350: hsl(46.046512, 97.727273%, 82.745098%);
  --nsw-yellow-400: hsl(46.666667, 96.116505%, 79.803922%);
  --nsw-yellow-450: hsl(43.902439, 93.89313%, 74.313725%);
  --nsw-yellow-500: hsl(42.119205, 93.78882%, 68.431373%);
  --nsw-yellow-550: hsl(40.434783, 94.845361%, 61.960784%);
  --nsw-yellow-600: hsl(41.632653, 96.078431%, 50%);
  --nsw-yellow-650: hsl(41.626794, 97.209302%, 42.156863%);
  --nsw-yellow-700: hsl(41.724138, 98.863636%, 34.509804%);
  --nsw-yellow-750: hsl(41.438849, 100%, 27.254902%);
  --nsw-yellow-800: hsl(41.142857, 100%, 20.588235%);
  --nsw-yellow-850: hsl(39.75, 100%, 15.686275%);
  --nsw-yellow-900: hsl(37.894737, 100%, 11.176471%);
  --nsw-yellow-950: hsl(33.529412, 100%, 6.666667%);
  --nsw-brown-50: hsl(34.285714, 46.666667%, 97.058824%);
  --nsw-brown-100: hsl(35, 40%, 94.117647%);
  --nsw-brown-150: hsl(31.764706, 39.534884%, 91.568627%);
  --nsw-brown-200: hsl(32.727273, 37.931034%, 88.627451%);
  --nsw-brown-250: hsl(32, 44.117647%, 86.666667%);
  --nsw-brown-300: hsl(33.333333, 46.153846%, 84.705882%);
  --nsw-brown-350: hsl(32.727273, 50%, 82.745098%);
  --nsw-brown-400: hsl(31.764706, 52.57732%, 80.980392%);
  --nsw-brown-450: hsl(32, 45.454545%, 74.117647%);
  --nsw-brown-500: hsl(31.714286, 42.168675%, 67.45098%);
  --nsw-brown-550: hsl(31.898734, 39.303483%, 60.588235%);
  --nsw-brown-600: hsl(32.359551, 37.87234%, 53.921569%);
  --nsw-brown-650: hsl(31.851852, 35.064935%, 45.294118%);
  --nsw-brown-700: hsl(31.666667, 38.297872%, 36.862745%);
  --nsw-brown-750: hsl(31.384615, 44.217687%, 28.823529%);
  --nsw-brown-800: hsl(31.578947, 53.271028%, 20.980392%);
  --nsw-brown-850: hsl(31.914894, 61.038961%, 15.098039%);
  --nsw-brown-900: hsl(31.666667, 72%, 9.803922%);
  --nsw-brown-950: hsl(28.695652, 85.185185%, 5.294118%);
  --nsw-aboriginal-grey-50: hsl(30, 14.285714%, 97.254902%);
  --nsw-aboriginal-grey-100: hsl(40, 10.344828%, 94.313725%);
  --nsw-aboriginal-grey-150: hsl(40, 6.976744%, 91.568627%);
  --nsw-aboriginal-grey-200: hsl(36, 8.77193%, 88.823529%);
  --nsw-aboriginal-grey-250: hsl(34.285714, 9.859155%, 86.078431%);
  --nsw-aboriginal-grey-300: hsl(25.714286, 8.235294%, 83.333333%);
  --nsw-aboriginal-grey-350: hsl(26.666667, 9.090909%, 80.588235%);
  --nsw-aboriginal-grey-400: hsl(24, 8.928571%, 78.039216%);
  --nsw-aboriginal-grey-450: hsl(22.5, 4.651163%, 66.27451%);
  --nsw-aboriginal-grey-500: hsl(15, 1.73913%, 54.901961%);
  --nsw-aboriginal-grey-550: hsl(30, 0.892857%, 43.921569%);
  --nsw-aboriginal-grey-600: hsl(0, 0%, 33.333333%);
  --nsw-aboriginal-grey-650: hsl(0, 0%, 28.627451%);
  --nsw-aboriginal-grey-700: hsl(0, 0%, 23.921569%);
  --nsw-aboriginal-grey-750: hsl(0, 0%, 19.607843%);
  --nsw-aboriginal-grey-800: hsl(0, 0%, 15.294118%);
  --nsw-aboriginal-grey-850: hsl(0, 0%, 10.980392%);
  --nsw-aboriginal-grey-900: hsl(0, 0%, 6.666667%);
  --nsw-aboriginal-grey-950: hsl(0, 0%, 2.745098%);
  --nsw-aboriginal-red-50: hsl(0, 100%, 98.039216%);
  --nsw-aboriginal-red-100: hsl(0, 100%, 96.078431%);
  --nsw-aboriginal-red-150: hsl(0, 93.333333%, 94.117647%);
  --nsw-aboriginal-red-200: hsl(0, 90%, 92.156863%);
  --nsw-aboriginal-red-250: hsl(0, 91.836735%, 90.392157%);
  --nsw-aboriginal-red-300: hsl(1.111111, 90%, 88.235294%);
  --nsw-aboriginal-red-350: hsl(0, 91.304348%, 86.470588%);
  --nsw-aboriginal-red-400: hsl(0.833333, 90%, 84.313725%);
  --nsw-aboriginal-red-450: hsl(1.8, 86.206897%, 77.254902%);
  --nsw-aboriginal-red-500: hsl(2.790698, 83.225806%, 69.607843%);
  --nsw-aboriginal-red-550: hsl(3.417722, 79%, 60.784314%);
  --nsw-aboriginal-red-600: hsl(3.045685, 77.865613%, 49.607843%);
  --nsw-aboriginal-red-650: hsl(2.637363, 79.824561%, 44.705882%);
  --nsw-aboriginal-red-700: hsl(2.485207, 83.251232%, 39.803922%);
  --nsw-aboriginal-red-750: hsl(2.307692, 87.640449%, 34.901961%);
  --nsw-aboriginal-red-800: hsl(1.258741, 92.258065%, 30.392157%);
  --nsw-aboriginal-red-850: hsl(359.482759, 100%, 22.745098%);
  --nsw-aboriginal-red-900: hsl(0, 100%, 16.470588%);
  --nsw-aboriginal-red-950: hsl(0, 100%, 10.588235%);
  --nsw-aboriginal-orange-50: hsl(25.263158, 100%, 96.27451%);
  --nsw-aboriginal-orange-100: hsl(21.818182, 94.285714%, 93.137255%);
  --nsw-aboriginal-orange-150: hsl(22.978723, 88.679245%, 89.607843%);
  --nsw-aboriginal-orange-200: hsl(22.372881, 83.098592%, 86.078431%);
  --nsw-aboriginal-orange-250: hsl(22.702703, 84.090909%, 82.745098%);
  --nsw-aboriginal-orange-300: hsl(22.247191, 84.761905%, 79.411765%);
  --nsw-aboriginal-orange-350: hsl(22.5, 85.245902%, 76.078431%);
  --nsw-aboriginal-orange-400: hsl(22.689076, 84.397163%, 72.352941%);
  --nsw-aboriginal-orange-450: hsl(22.12766, 85.454545%, 67.647059%);
  --nsw-aboriginal-orange-500: hsl(21.349693, 86.243386%, 62.941176%);
  --nsw-aboriginal-orange-550: hsl(20.967742, 86.111111%, 57.647059%);
  --nsw-aboriginal-orange-600: hsl(21.743119, 86.507937%, 50.588235%);
  --nsw-aboriginal-orange-650: hsl(20.510204, 85.964912%, 44.705882%);
  --nsw-aboriginal-orange-700: hsl(19.772727, 89.795918%, 38.431373%);
  --nsw-aboriginal-orange-750: hsl(18.461538, 93.975904%, 32.54902%);
  --nsw-aboriginal-orange-800: hsl(16.764706, 100%, 26.666667%);
  --nsw-aboriginal-orange-850: hsl(14.285714, 100%, 20.588235%);
  --nsw-aboriginal-orange-900: hsl(10.263158, 100%, 14.901961%);
  --nsw-aboriginal-orange-950: hsl(3.75, 100%, 9.411765%);
  --nsw-aboriginal-brown-50: hsl(25.263158, 76%, 95.098039%);
  --nsw-aboriginal-brown-100: hsl(23.225806, 63.265306%, 90.392157%);
  --nsw-aboriginal-brown-150: hsl(23.72093, 57.333333%, 85.294118%);
  --nsw-aboriginal-brown-200: hsl(24, 55.555556%, 80.588235%);
  --nsw-aboriginal-brown-250: hsl(23.478261, 56.097561%, 75.882353%);
  --nsw-aboriginal-brown-300: hsl(24.146341, 55.405405%, 70.980392%);
  --nsw-aboriginal-brown-350: hsl(24.123711, 56.069364%, 66.078431%);
  --nsw-aboriginal-brown-400: hsl(24, 55.555556%, 61.176471%);
  --nsw-aboriginal-brown-450: hsl(22.363636, 49.107143%, 56.078431%);
  --nsw-aboriginal-brown-500: hsl(21.272727, 44%, 50.980392%);
  --nsw-aboriginal-brown-550: hsl(19.816514, 46.781116%, 45.686275%);
  --nsw-aboriginal-brown-600: hsl(18.333333, 51.923077%, 40.784314%);
  --nsw-aboriginal-brown-650: hsl(18.6, 56.179775%, 34.901961%);
  --nsw-aboriginal-brown-700: hsl(18.709677, 62.416107%, 29.215686%);
  --nsw-aboriginal-brown-750: hsl(20, 73.109244%, 23.333333%);
  --nsw-aboriginal-brown-800: hsl(21, 88.888889%, 17.647059%);
  --nsw-aboriginal-brown-850: hsl(19.047619, 94.029851%, 13.137255%);
  --nsw-aboriginal-brown-900: hsl(16, 100%, 8.823529%);
  --nsw-aboriginal-brown-950: hsl(8.888889, 100%, 5.294118%);
  --nsw-aboriginal-yellow-50: hsl(49.411765, 100%, 96.666667%);
  --nsw-aboriginal-yellow-100: hsl(46.451613, 100%, 93.921569%);
  --nsw-aboriginal-yellow-150: hsl(46.363636, 100%, 91.372549%);
  --nsw-aboriginal-yellow-200: hsl(45.517241, 100%, 88.627451%);
  --nsw-aboriginal-yellow-250: hsl(45.833333, 100%, 85.882353%);
  --nsw-aboriginal-yellow-300: hsl(46.046512, 100%, 83.137255%);
  --nsw-aboriginal-yellow-350: hsl(46.060606, 98.019802%, 80.196078%);
  --nsw-aboriginal-yellow-400: hsl(46.315789, 98.275862%, 77.254902%);
  --nsw-aboriginal-yellow-450: hsl(42.481752, 98.561151%, 72.745098%);
  --nsw-aboriginal-yellow-500: hsl(39.875776, 98.773006%, 68.039216%);
  --nsw-aboriginal-yellow-550: hsl(37.741935, 98.93617%, 63.137255%);
  --nsw-aboriginal-yellow-600: hsl(36.27907, 99.078341%, 57.45098%);
  --nsw-aboriginal-yellow-650: hsl(37.538462, 77.689243%, 49.215686%);
  --nsw-aboriginal-yellow-700: hsl(38.742857, 82.938389%, 41.372549%);
  --nsw-aboriginal-yellow-750: hsl(39.873418, 91.860465%, 33.72549%);
  --nsw-aboriginal-yellow-800: hsl(41.167883, 100%, 26.862745%);
  --nsw-aboriginal-yellow-850: hsl(40.571429, 100%, 20.588235%);
  --nsw-aboriginal-yellow-900: hsl(37.894737, 100%, 14.901961%);
  --nsw-aboriginal-yellow-950: hsl(35.744681, 100%, 9.215686%);
  --nsw-aboriginal-green-50: hsl(94.285714, 36.842105%, 96.27451%);
  --nsw-aboriginal-green-100: hsl(95, 33.333333%, 92.941176%);
  --nsw-aboriginal-green-150: hsl(93.75, 29.62963%, 89.411765%);
  --nsw-aboriginal-green-200: hsl(94.285714, 29.577465%, 86.078431%);
  --nsw-aboriginal-green-250: hsl(94.615385, 29.545455%, 82.745098%);
  --nsw-aboriginal-green-300: hsl(94.83871, 28.971963%, 79.019608%);
  --nsw-aboriginal-green-350: hsl(95, 29.032258%, 75.686275%);
  --nsw-aboriginal-green-400: hsl(95.121951, 29.078014%, 72.352941%);
  --nsw-aboriginal-green-450: hsl(93.461538, 29.885057%, 65.882353%);
  --nsw-aboriginal-green-500: hsl(91.875, 30.769231%, 59.215686%);
  --nsw-aboriginal-green-550: hsl(90, 31.404959%, 52.54902%);
  --nsw-aboriginal-green-600: hsl(87.032967, 39.393939%, 45.294118%);
  --nsw-aboriginal-green-650: hsl(98.4, 35.545024%, 41.372549%);
  --nsw-aboriginal-green-700: hsl(111.147541, 32.275132%, 37.058824%);
  --nsw-aboriginal-green-750: hsl(127.777778, 34.177215%, 30.980392%);
  --nsw-aboriginal-green-800: hsl(140.727273, 45.454545%, 23.72549%);
  --nsw-aboriginal-green-850: hsl(141.333333, 51.724138%, 17.058824%);
  --nsw-aboriginal-green-900: hsl(141.666667, 64.285714%, 10.980392%);
  --nsw-aboriginal-green-950: hsl(139.2, 86.206897%, 5.686275%);
  --nsw-aboriginal-blue-50: hsl(190, 54.545455%, 95.686275%);
  --nsw-aboriginal-blue-100: hsl(188.571429, 48.837209%, 91.568627%);
  --nsw-aboriginal-blue-150: hsl(190, 46.875%, 87.45098%);
  --nsw-aboriginal-blue-200: hsl(189.230769, 45.882353%, 83.333333%);
  --nsw-aboriginal-blue-250: hsl(188.75, 45.283019%, 79.215686%);
  --nsw-aboriginal-blue-300: hsl(188.421053, 44.88189%, 75.098039%);
  --nsw-aboriginal-blue-350: hsl(189.850746, 45.578231%, 71.176471%);
  --nsw-aboriginal-blue-400: hsl(189.350649, 45.56213%, 66.862745%);
  --nsw-aboriginal-blue-450: hsl(192.134831, 41.395349%, 57.843137%);
  --nsw-aboriginal-blue-500: hsl(195.294118, 40.8%, 49.019608%);
  --nsw-aboriginal-blue-550: hsl(197.73913, 55.555556%, 40.588235%);
  --nsw-aboriginal-blue-600: hsl(199.090909, 83.544304%, 30.980392%);
  --nsw-aboriginal-blue-650: hsl(199.02439, 87.234043%, 27.647059%);
  --nsw-aboriginal-blue-700: hsl(198.947368, 91.935484%, 24.313725%);
  --nsw-aboriginal-blue-750: hsl(199.038462, 96.296296%, 21.176471%);
  --nsw-aboriginal-blue-800: hsl(199.148936, 100%, 18.431373%);
  --nsw-aboriginal-blue-850: hsl(200.833333, 100%, 14.117647%);
  --nsw-aboriginal-blue-900: hsl(202.352941, 100%, 10%);
  --nsw-aboriginal-blue-950: hsl(207.096774, 100%, 6.078431%);
  --nsw-aboriginal-purple-50: hsl(313.333333, 47.368421%, 96.27451%);
  --nsw-aboriginal-purple-100: hsl(309.230769, 33.333333%, 92.352941%);
  --nsw-aboriginal-purple-150: hsl(309.473684, 32.20339%, 88.431373%);
  --nsw-aboriginal-purple-200: hsl(310, 30.769231%, 84.705882%);
  --nsw-aboriginal-purple-250: hsl(310, 30.612245%, 80.784314%);
  --nsw-aboriginal-purple-300: hsl(310, 31.034483%, 77.254902%);
  --nsw-aboriginal-purple-350: hsl(310, 30.882353%, 73.333333%);
  --nsw-aboriginal-purple-400: hsl(308.93617, 30.322581%, 69.607843%);
  --nsw-aboriginal-purple-450: hsl(308.4, 27.472527%, 64.313725%);
  --nsw-aboriginal-purple-500: hsl(307.924528, 25.358852%, 59.019608%);
  --nsw-aboriginal-purple-550: hsl(307.368421, 24.255319%, 53.921569%);
  --nsw-aboriginal-purple-600: hsl(307, 24.193548%, 48.627451%);
  --nsw-aboriginal-purple-650: hsl(306.792453, 25.118483%, 41.372549%);
  --nsw-aboriginal-purple-700: hsl(307.826087, 26.136364%, 34.509804%);
  --nsw-aboriginal-purple-750: hsl(309, 28.169014%, 27.843137%);
  --nsw-aboriginal-purple-800: hsl(309.090909, 30.275229%, 21.372549%);
  --nsw-aboriginal-purple-850: hsl(308.888889, 34.177215%, 15.490196%);
  --nsw-aboriginal-purple-900: hsl(309, 38.461538%, 10.196078%);
  --nsw-aboriginal-purple-950: hsl(312, 55.555556%, 5.294118%);
  --success-50: hsl(110, 50%, 95.294118%);
  --success-100: hsl(114.285714, 46.666667%, 91.176471%);
  --success-150: hsl(113.793103, 43.283582%, 86.862745%);
  --success-200: hsl(113.513514, 41.573034%, 82.54902%);
  --success-250: hsl(113.877551, 37.40458%, 74.313725%);
  --success-300: hsl(115.081967, 35.260116%, 66.078431%);
  --success-350: hsl(115.833333, 33.333333%, 57.647059%);
  --success-400: hsl(117.142857, 33.333333%, 49.411765%);
  --success-450: hsl(118.021978, 39.393939%, 45.294118%);
  --success-500: hsl(118.181818, 47.826087%, 40.588235%);
  --success-550: hsl(119.454545, 60.43956%, 35.686275%);
  --success-600: hsl(123.043478, 100%, 27.058824%);
  --success-650: hsl(122.105263, 100%, 22.352941%);
  --success-700: hsl(121.333333, 100%, 17.647059%);
  --success-750: hsl(120.882353, 100%, 13.333333%);
  --success-800: hsl(120, 100%, 9.215686%);
  --success-850: hsl(120, 100%, 6.666667%);
  --success-900: hsl(120, 100%, 4.313725%);
  --success-950: hsl(120, 100%, 2.156863%);
  --warning-50: hsl(20, 100%, 96.470588%);
  --warning-100: hsl(18.181818, 100%, 93.529412%);
  --warning-150: hsl(17.5, 100%, 90.588235%);
  --warning-200: hsl(17.704918, 93.846154%, 87.254902%);
  --warning-250: hsl(17.777778, 81.818182%, 80.588235%);
  --warning-300: hsl(18, 74.626866%, 73.72549%);
  --warning-350: hsl(18.151261, 70.414201%, 66.862745%);
  --warning-400: hsl(18.26087, 66.990291%, 59.607843%);
  --warning-450: hsl(18.648649, 65.486726%, 55.686275%);
  --warning-500: hsl(19.245283, 64.37247%, 51.568627%);
  --warning-550: hsl(20.462428, 72.384937%, 46.862745%);
  --warning-600: hsl(23.880597, 100%, 39.411765%);
  --warning-650: hsl(21.818182, 96.491228%, 33.529412%);
  --warning-700: hsl(19.849624, 95.683453%, 27.254902%);
  --warning-750: hsl(17.884615, 98.113208%, 20.784314%);
  --warning-800: hsl(14.4, 100%, 14.705882%);
  --warning-850: hsl(10.526316, 100%, 11.176471%);
  --warning-900: hsl(6.153846, 100%, 7.647059%);
  --warning-950: hsl(2.608696, 100%, 4.509804%);
  --danger-50: hsl(3.75, 100%, 96.862745%);
  --danger-100: hsl(2, 100%, 94.117647%);
  --danger-150: hsl(0, 100%, 91.568627%);
  --danger-200: hsl(0, 93.220339%, 88.431373%);
  --danger-250: hsl(359.166667, 76.595745%, 81.568627%);
  --danger-300: hsl(358.636364, 67.692308%, 74.509804%);
  --danger-350: hsl(357.669903, 61.676647%, 67.254902%);
  --danger-400: hsl(355.932203, 57.281553%, 59.607843%);
  --danger-450: hsl(354.80315, 55.947137%, 55.490196%);
  --danger-500: hsl(353.333333, 54.216867%, 51.176471%);
  --danger-550: hsl(351.020408, 62.553191%, 46.078431%);
  --danger-600: hsl(346.626506, 82.178218%, 39.607843%);
  --danger-650: hsl(346.901408, 86.585366%, 32.156863%);
  --danger-700: hsl(347.288136, 90.769231%, 25.490196%);
  --danger-750: hsl(348.387097, 95.876289%, 19.019608%);
  --danger-800: hsl(351.176471, 100%, 13.333333%);
  --danger-850: hsl(354.117647, 100%, 10%);
  --danger-900: hsl(356.571429, 100%, 6.862745%);
  --danger-950: hsl(357, 100%, 3.921569%);
  --info-50: hsl(218.571429, 46.666667%, 94.117647%);
  --info-100: hsl(216.521739, 36.507937%, 87.647059%);
  --info-150: hsl(217.5, 34.042553%, 81.568627%);
  --info-200: hsl(218.04878, 32.8%, 75.490196%);
  --info-250: hsl(218.888889, 34.615385%, 69.411765%);
  --info-300: hsl(218.181818, 35.106383%, 63.137255%);
  --info-350: hsl(218.961039, 35.159817%, 57.058824%);
  --info-400: hsl(219.310345, 34.939759%, 51.176471%);
  --info-450: hsl(219.782609, 37.398374%, 48.235294%);
  --info-500: hsl(219.183673, 42.608696%, 45.098039%);
  --info-550: hsl(219.411765, 47.663551%, 41.960784%);
  --info-600: hsl(219.813084, 53.768844%, 39.019608%);
  --info-650: hsl(219.782609, 56.790123%, 31.764706%);
  --info-700: hsl(219.74026, 60.629921%, 24.901961%);
  --info-750: hsl(220, 66.315789%, 18.627451%);
  --info-800: hsl(220.408163, 77.777778%, 12.352941%);
  --info-850: hsl(222.631579, 82.608696%, 9.019608%);
  --info-900: hsl(228.461538, 86.666667%, 5.882353%);
  --info-950: hsl(228, 100%, 2.941176%);
  --white: hsl(0, 0%, 100%);
  --black: hsl(0, 0%, 0%);
}
